import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Inject,
    OnDestroy,
    OnInit,
    ViewChild,
} from "@angular/core";
import { Subscription, fromEvent, merge } from "rxjs";
import { debounceTime } from "rxjs/operators";

import { Context, WINDOW } from "@hermes/app-core";
import { GridFacade } from "@hermes/states/grid-filters-state";
import { ENTER, SPACE } from "@hermes/utils-generic/constants";

import { isLoadMoreInViewport } from "../../helpers/viewport.helper";

export const DEBOUNCE_TIMER_MILLISECONDS = 100;
@Component({
    selector: "h-grid-result-footer",
    templateUrl: "./grid-result-footer.component.html",
    styleUrls: ["./grid-result-footer.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridResultFooterComponent
    implements OnInit, OnDestroy, AfterViewInit
{
    @ViewChild("gridFooter")
    public gridFooter!: ElementRef;
    /**
     * Display the load more
     */
    public displayed: boolean = false;
    /**
     * Is the grid footer load more button has been activated
     */
    public activated: boolean = false;
    /**
     * Is merchandising service fetching products
     */
    public fetchingMore: boolean = false;

    public subscription: Subscription = new Subscription();

    constructor(
        @Inject(WINDOW) private window: Window,
        private readonly gridFacade: GridFacade,
        private readonly context: Context,
        private changeDetector: ChangeDetectorRef,
    ) {}

    public ngOnInit(): void {
        this.subscription.add(
            this.gridFacade.loadMore$.subscribe((loadMore) => {
                this.displayed = loadMore.displayed;
                this.activated = loadMore.activated;
                this.fetchingMore = loadMore.pending;
                this.changeDetector.markForCheck();
            }),
        );
    }

    public ngAfterViewInit(): void {
        if (this.context.isInBrowserMode()) {
            this.subscription.add(
                merge(
                    fromEvent(this.window, "scroll"),
                    fromEvent(this.window, "resize"),
                )
                    .pipe(debounceTime(DEBOUNCE_TIMER_MILLISECONDS))
                    .subscribe(() => this.onEvent()),
            );
        }
    }

    public ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    public handleKeyPress($event: KeyboardEvent): void {
        switch ($event.key) {
            case SPACE:
            case ENTER: {
                $event.preventDefault();
                this.gridFacade.loadMoreProducts();
                break;
            }
            default: {
                break;
            }
        }
    }

    public handleClick($event: MouseEvent): void {
        $event.preventDefault();
        this.gridFacade.loadMoreProducts();
    }

    public onEvent(): void {
        if (
            this.activated &&
            this.displayed &&
            isLoadMoreInViewport(this.gridFooter.nativeElement) &&
            !this.fetchingMore
        ) {
            this.gridFacade.loadMoreProducts();
        }
    }
}
